<div #closeDiv class="add-payment">
  <div class="ui-g-12 p-zero dialog-header">
    <div class="send-dialog-heading">
      <span *ngIf="!isProcessing">Enter your card information</span>
      <span *ngIf="isProcessing"
        >Please wait
        <i class="fal fa-spinner rotate"></i>
      </span>
    </div>
    <i class="fal fa-times fa-sm dialog-close" (click)="closePaymentModal(false, {})"></i>
  </div>
  <!-- body -->
  <div class="dialog-body">
    <!-- customer details -->
    <div class="ui-g-12 mb-2 payment-date customer-details-font d-flex align-items-center">
      <div class="col-md-1 d-md-block d-none">
        <span style="font-size: 29px;">
          <i class="fal fa-file-invoice"></i>
        </span>
      </div>
      <div class="col-md-11">
        <table class="table shopData" style="margin-bottom: 0rem;">
          <tbody>
            <tr>
              <td>Customer:</td>
              <td><strong>{{ payment?.customer?.fullName }}</strong></td>
            </tr>
            <tr>
              <td>RO / Invoice #:</td>
              <td><strong>{{ payment?.code }} {{ payment?.estimate?.invCode ? '/ ' + payment?.estimate?.invCode : '' }}</strong></td>
            </tr>
            <tr>
              <td>Payment amount:</td>
              <td><strong style="color: var(--primary-900);">USD {{ usdPayment }}</strong></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- payment details -->
    <div class="ui-g-12 payment-date">
      <div class="ui-g-8 customer-details-font">
        Payment methods
      </div>
      <div class="ui-g-4 p-0">
        <img src="../../../../../assets/Card-Brand-Logos.png" alt="" width="85%" class="d-block ml-auto"/>
      </div>
      <div class="ui-g-12 payrix-error" *ngIf="payrixErrorMsg">
        <p>
          <i class="fal fa-info-circle text-dark pr-2"></i>
          <span>{{payrixErrorMsg}}</span>
        </p>
      </div>
      <div class="ui-g-12 payrix-payment-form">
        <div class="row">
          <div class="col-md-1 col-2 text-center">
            <i class="fal fa-stream"></i>
          </div>
          <div class="col-md-11 col-10">
            <label for="name">Name on card*</label>
            <div style="height: 50px !important; margin-top: -10px !important;" id="name"></div>
          </div>
        </div>
        <!--  -->
        <div class="row">
          <div class="col-md-6">
            <div class="row">
              <div class="col-2 text-center">
                <i class="fal fa-credit-card-front"></i>
              </div>
              <div class="col-10">
                <label for="number">Card Number*</label>
                <div style="height: 50px !important; margin-top: -10px !important;" id="number"></div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-2 text-center">
                <i class="fal fa-calendar-alt"></i>
              </div>
              <div class="col-10">
                <label for="expiration">Expiration Date*</label>
                <div style="height: 50px !important; margin-top: -10px !important;" id="expiration"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="row">
              <div class="col-2 text-center">
                <i class="fal fa-credit-card"></i>
              </div>
              <div class="col-10">
                <label for="cvv">CVV / Security Code*</label>
                <div style="height: 50px !important; margin-top: -10px !important;" id="cvv"></div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-2 text-center">
                <i class="fal fa-map-pin"></i>
              </div>
              <div class="col-10">
                <label style="margin-bottom: 0px;" for="zip">Zip*</label>
                <app-input style="display: block;" class="card-zip-field" id="zip" placeholder="ZIP / PIN code*" [value]="zip" (appChange)="zipChange($event)"></app-input>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- privacy policy  -->
    <div *ngIf="!isProcessing" class="ui-g-12 mt-2 privacy-policy payment-date">
      <div>
        <span class="font-11">
          <b>Return and refund policy:</b> The merchant reserves the right to decline any request for refund due to services rendered. Please contact us in case of any queries or concerns
        </span>
      </div>
      <div class="address-fields">
        <span>{{company?.name}}</span>
      </div>
      <!-- color gray-45, font-10 -->
      <div class="address-fields">
        <span> {{ company?.address?.addLine1 }}, </span>
        <span> {{ company?.address?.addLine2 }}, </span>
        <span>{{ company?.address?.city }}, {{ company?.address?.stateCode }}, </span>
        <span> {{ company?.address?.zip }} , </span>
        <span> {{ company?.address?.country }} </span>
      </div>
      <div class="address-fields">
        <span>Phone #: {{ company?.phone | mask: '(000) 000-0000' }} | </span>
        <span>Email: {{ company?.email }} |</span>
        <span
          ><a href="{{ redirect }}" target="_blank">
            Privacy and Security Policy
          </a></span
        >
      </div>
    </div>
  </div>

  <!-- footer -->
  <div *ngIf="!isProcessing" class="ui-g-12 p-zero dialog-footer">
    <div class="ui-g-8 p-1 text-right float-right payment-add-footer">
      <button id="payment-btn-cancel" class="btn btn-white btn-border pointer btn-submit mr-1" (click)="closePaymentModal(false, {})">Cancel</button>
      <button [disabled]="isSubmitting || !zip" id="payment-btn-save" class="btn btn-primary btn-submit" (click)="payRixAPI()">
        <span class="pr-2">Pay Now</span>
        <i *ngIf="isSubmitting" class="fal fa-spinner rotate"></i>
      </button>
    </div>
  </div>
</div>
